import styled from 'styled-components'
import { Theme } from '../../Theme';


const  Content = styled.div`
    display:flex;
`;

export const Styled = {
    Content
}